import React from 'react';
import { colors } from 'styleguide';

interface Props {
  size?: number;
  color?: string;
}

const ListNumbered = ({ size = 16, color = colors('neutral', 3) }: Props) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <line
      x1="6.45459"
      y1="4.63623"
      x2="19"
      y2="4.63623"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path d="M1.37587 2.736V3.474L2.04787 3.186V6H2.88787V2.016L1.37587 2.736Z" fill="#333745" />
    <path
      d="M3.49117 10.6626H2.27917L3.18517 9.63656C3.46117 9.32456 3.59917 8.99456 3.59917 8.64056C3.59917 8.29256 3.47317 8.00456 3.22117 7.78256C2.97517 7.56056 2.66917 7.44656 2.31517 7.44656C1.57717 7.44656 1.06117 7.91456 0.941173 8.66456L1.70917 8.79656C1.75717 8.47856 1.97317 8.25056 2.26717 8.25056C2.57317 8.25056 2.75917 8.42456 2.75917 8.64056C2.75917 8.77856 2.68717 8.92256 2.54917 9.08456L0.935173 10.9986V11.4546H3.49117V10.6626Z"
      fill="#333745"
    />
    <path
      d="M2.16545 15.1142C2.75345 15.0962 2.71145 15.5582 2.69945 15.6362C2.67545 15.8522 2.42345 16.0742 2.13545 16.0562C2.02145 16.0502 1.90745 16.0142 1.79345 15.9362C1.67945 15.8582 1.59545 15.7682 1.55345 15.6782L0.815454 16.0442C1.03145 16.5002 1.52345 16.8362 2.06945 16.8662C2.45945 16.8962 2.80745 16.8002 3.11345 16.5842C3.41945 16.3622 3.58745 16.0862 3.61745 15.7502C3.63545 15.5342 3.58145 15.3242 3.45545 15.1142C3.32945 14.9042 3.15545 14.7602 2.94545 14.6822C3.25145 14.5142 3.44945 14.2262 3.44945 13.9142C3.45545 13.6322 3.34745 13.3802 3.12545 13.1642C2.90345 12.9422 2.62145 12.8282 2.28545 12.8102C1.76345 12.7802 1.30145 13.0142 1.06145 13.3922L1.73945 13.8062C1.82945 13.6622 1.96745 13.5902 2.15345 13.5902C2.41745 13.5902 2.54945 13.8062 2.54945 13.9682C2.54945 14.2502 2.42345 14.3942 2.16545 14.3942H1.75145V15.1142H2.16545Z"
      fill={color}
    />
    <line
      x1="6.45455"
      y1="15.4545"
      x2="19"
      y2="15.4545"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
    />
    <line
      x1="6.45455"
      y1="10"
      x2="19"
      y2="10"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export default ListNumbered;
